import { useState, useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import loadable from '@loadable/component'
import Button from 'components/forms/Button'
import NavDropdown from 'components/navbar/NavDropdown'
import Avatar from 'components/misc/Avatar'
import { setMode } from 'store/login-modal/actions'
import { toggleModal, logout } from 'store/ui/actions'
import styles from './styles/NavLogin.css'
import HoverLink from './HoverLink'

const OnboardingTooltip = loadable(() => import('components/navbar/onboarding/Tooltip'))

const NavLogin = ({ avatarBg = 'gray', buttonColor = 'transparent', showSignup }) => {
  const user = useSelector(({ ui: { user } }) => user)
  const fetchingUser = useSelector(({ ui: { fetchingUser } }) => fetchingUser)
  const dispatch = useDispatch()
  const [closeOnboarding, setCloseOnboarding] = useState(false)
  const [hasToken, setHasToken] = useState(null)

  useEffect(() => {
    const token = window?.localStorage?.getItem('apiToken') || null
    setHasToken(!!token)
  }, [])

  const avatarItems = user
    ? [
        {
          name: 'My Profile',
          href: `/users/${user.slug}`
        },
        {
          name: 'Tools',
          href: `/users/${user.slug}/dashboards`
        },
        {
          name: 'Account Settings',
          href: `/users/${user.slug}/account-settings`
        },
        {
          name: 'Subscription',
          href: `/users/${user.slug}/subscription`
        },
        {
          name: 'Pricing',
          href: '/pricing'
        },
        {
          name: (
            <>
              {(user?.subscription?.plan === 'free' || user?.subscription?.status === 'trialing')
                ? (
                  <span className={styles.referralsPromotion}>Get 40% off!</span>
                  )
                : (
                    'Invite Others'
                  )}
            </>
          ),
          href: `/users/${user.slug}/referrals`
        },
        {
          name: 'Get Help!',
          href: `/users/${user.slug}/help`
        },
        {
          name: 'Sign Out',
          onClick: () => dispatch(logout())
        }
      ]
    : []

  const handleSignin = () => {
    dispatch(setMode('login'))
    dispatch(toggleModal('login'))
  }

  const handleSignup = () => {
    dispatch(setMode('register'))
    dispatch(toggleModal('login'))
  }

  //
  // Initial render
  //
  if (hasToken === null) {
    return null
  }

  //
  // Keep it empty if we are fetching
  //
  if (hasToken === true && fetchingUser) {
    return null
  }

  if (user?.email) {
    return (
      <OnboardingTooltip
        header='See everything you can do with scite'
        content={[
          'Click here to view and manage your reference checks, email alerts, dashboards, saved searches and other scite tools.'
        ]}
        placement='bottom'
        closeOnboarding={closeOnboarding}
      >
        <NavDropdown dropdownClassName={styles.avatarWrapper} items={avatarItems} menuOffset={[-45, 12]}>
          <Avatar onClick={() => setCloseOnboarding(true)} src={user.avatar} bg={avatarBg} />
        </NavDropdown>
      </OnboardingTooltip>
    )
  }

  return (
    showSignup
      ? (
        <div className={styles.buttonLayout}>
          <HoverLink onClick={handleSignin}>Sign in</HoverLink>
          <Button
            className={styles.button}
            onClick={handleSignup}
            color={buttonColor}
            bold
            small
          >
            Sign Up
          </Button>
        </div>
        )
      : (
        <div className={styles.buttonLayout}>
          <Button
            className={styles.button}
            onClick={handleSignin}
            color={buttonColor}
            bold
            small
          >
            Sign In
          </Button>
        </div>
        )
  )
}

export default NavLogin
